import React from 'react'
import { Link } from 'react-router'
import cn from 'classnames'
import s from './Sidebar.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { get } from 'lodash'
import Button from 'components/Button'
import AnimationFade from 'components/Animation/AnimationFade'
import AnimationShowHide from 'components/Animation/AnimationShowHide'
import IconDashboard from 'components/Icons/Dashboard'
import IconNumbers from 'components/Icons/Numbers'
import IconSupport from 'components/Icons/Support'
import IconBilling from 'components/Icons/Billing'
import IconFlow from 'components/Icons/Flow'
import IconPhones from 'components/Icons/Phones'
import IconAnalytics from 'components/Icons/Analytics'
import IconContact from 'components/Icons/Contact'
import IconRecordTape from 'components/Icons/RecordTape'
import IconUserVoice from 'components/Icons/UserVoice'
import IconMessageLine from 'components/Icons/MessageLine'
import IconInternet from 'components/Icons/Internet'
import IconPhoneLines from 'components/Icons/PhoneLines'
import IconUser from 'components/Icons/User'

const links = [
  {
    name: 'Dashboard',
    to: '/dashboard',
    icon: <IconDashboard />,
  },
  {
    name: 'Phone Numbers',
    to: '/dashboard/numbers',
    icon: <IconNumbers />,
  },
  {
    name: 'Call Analytics',
    to: '/dashboard/analytics',
    icon: <IconAnalytics />,
  },
  {
    name: 'Call Recordings',
    to: '/dashboard/recordings',
    icon: <IconRecordTape />,
  },
  {
    name: 'SMS Messages',
    to: '/dashboard/messages',
    icon: <IconMessageLine />,
  },
  {
    name: 'Flow Builder',
    to: '/dashboard/flows',
    icon: <IconFlow />,
  },
  {
    name: 'Hosted Voice',
    to: '/dashboard/hosted-voice',
    icon: <IconPhones />,
  },
  {
    name: 'Contacts',
    to: '/dashboard/contacts',
    icon: <IconContact />,
  },
  {
    name: 'Voice Actor Recordings',
    to: '/dashboard/voice-actor-recordings',
    icon: <IconUserVoice />,
  },
  {
    name: 'Business Internet',
    to: '/dashboard/internet',
    icon: <IconInternet />,
  },
  {
    name: 'Phone Lines',
    to: '/dashboard/phone-lines',
    icon: <IconPhoneLines />,
  },
  {
    name: 'Billing',
    to: '/dashboard/billing',
    icon: <IconBilling />,
  },
  {
    name: 'Support Cases',
    to: '/dashboard/cases',
    icon: <IconSupport />,
  },
  {
    name: 'Settings',
    to: '/dashboard/settings',
    icon: <IconUser />,
  },
  {
    name: 'Admin - Users',
    to: '/admin/users',
    icon: <IconContact />,
    adminOnly: true,
  },
]

const otherLinks = [
  {
    name: 'Privacy Policy',
    to: '/privacy',
  },
  {
    name: 'Terms of Use',
    to: '/portal-terms',
  },
]

export default props => {
  const { layout, toggleMenu, logout, pathname, user, switchBackToAdmin, adminUserId } = props
  const isOpen = layout.menuOpen && (pathname.includes('/dashboard') || pathname.includes('/admin'))
  const isProduction = window.GLOBAL_ENV.API_TYPE === 'production'
  const linksFiltered = links.filter(link => {
    const userHasPermission = !link.adminOnly || get(user, 'roles', []).includes('ROLE_API_ADMIN')
    const isNotHiddenInProduction = !link.hideProduction || !(link.hideProduction && isProduction)
    return userHasPermission && isNotHiddenInProduction
  })

  return (
    <div className={sLay['layout-column']}>
      <AnimationShowHide
        in={isOpen}
        timeout={500}
        classNames={{
          enter: s.fadeEnter,
          enterActive: s.fadeEnterActive,
          exit: s.fadeExit,
          exitActive: s.fadeExitActive,
        }}
      >
        <div className={cn(s.sidebar, sLay['flex-noshrink'], sLay['layout-column'])}>
          <div className={cn(sLay['layout-column'], sLay['flex-noshrink'], s.inner)}>
            <div>
              {linksFiltered.map(link => (
                <Link
                  className={cn(s.link, sLay['layout-row'], sLay['layout-align-start-center'], {
                    [s.active]:
                      link.to === '/dashboard' ? pathname === link.to : pathname.includes(link.to),
                  })}
                  key={link.name}
                  to={link.to}
                >
                  {link.icon}
                  {link.name}
                </Link>
              ))}
            </div>
            <div className={s.divider} />
            <div>
              {otherLinks.map(link => (
                <Link
                  key={link.name}
                  className={s.otherLink}
                  target="_blank"
                  to={link.to}
                  activeClassName={s.active}
                >
                  {link.name}
                </Link>
              ))}
            </div>
            <div className={sLay.flex} />
            <div className={cn(s.footer)}>
              <div className={cn(s.user, sText.ellipsis)}>User: {user.username}</div>
              <div className={cn(sLay['layout-row'], sLay['layout-align-start-center'])}>
                <div className={cn(s.copyright)}>© Think Pickle {new Date().getFullYear()}</div>
                <div className={sLay.flex} />
                <Button className={s.logout} size="xs" color="tertiary" onClick={logout}>
                  Logout
                </Button>
              </div>
              {adminUserId && (
                <Button
                  size="xs"
                  style={{ width: '100%', marginTop: '10px' }}
                  color="warn"
                  onClick={switchBackToAdmin}
                >
                  Switch back to admin
                </Button>
              )}
            </div>
          </div>
        </div>
      </AnimationShowHide>
      <AnimationFade in={isOpen}>
        <div className={s.overlay} onClick={() => toggleMenu()} />
      </AnimationFade>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx